import { useMemo } from 'react';

import { getAdminUrl } from '../../utilities';
import { useHasExternals } from '../../shared';

const admin: AppRouteType = {
  icon: 'link',
  external: true,
  url: getAdminUrl(),
  menuTitle: 'Go to Admin',
};

export const useExternals: () => AppRouteType[] = () => {
  const hasAdmin = useHasExternals();

  return useMemo(() => (hasAdmin ? [admin] : []), [hasAdmin]);
};
